import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { DeliverySection } from '../components/home/DeliverySection';
import { ProductsSection } from '../components/home/ProductsSection';
import { AboutSection } from '../components/home/AboutSection';
import { ContactSection } from '../components/home/ContactSection';
export function Home() {
  return <>
      <HeroSection data-id="element-193" data-mp="1zi7aq14p8y52" />
      <ProductsSection data-id="element-194" data-mp="1ziqulndwtwlq" />
      <DeliverySection data-id="element-195" data-mp="1zj8vwyffj10i" />
      <AboutSection data-id="element-196" data-mp="1zk1zjqj3daef" />
      <ContactSection data-id="element-197" data-mp="24h0n1q892j3n" />
    </>;
}